'use client'

import { LanguagesIcon } from 'lucide-react'
import { useLocale, useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { LOCALES, type Locale } from '@/i18n/config'
import { setUserLocale } from '@/i18n/locale'

// INFO: portaled menus escape themed wrappers - marketing passes "dark" so the popover matches the shell
export function LocaleSwitcher({
	contentClassName,
	sideOffset,
}: { contentClassName?: string; sideOffset?: number } = {}) {
	const t = useTranslations('common')
	const locale = useLocale()
	const router = useRouter()
	const [isPending, startTransition] = useTransition()

	const changeLocale = (next: string) => {
		startTransition(async () => {
			await setUserLocale(next as Locale)
			router.refresh()
		})
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				render={<Button variant="ghost" size="icon" aria-label={t('language')} disabled={isPending} />}
			>
				<LanguagesIcon />
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" sideOffset={sideOffset} className={contentClassName}>
				<DropdownMenuRadioGroup value={locale} onValueChange={changeLocale}>
					{LOCALES.map((option) => (
						<DropdownMenuRadioItem key={option} value={option} closeOnClick>
							{t(`locale.${option}`)}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
